module.exports = __webpack_public_path__ + "static/media/student.5e644836.png";